import React from 'react';
import './css/About.css';

export default () => (
  <div className="about">
    Diva Models was founded in 1987.
    <br />
    <br />
    With offices in Aarhus and Copenhagen, Denmark, Diva Models is one of the most established
    model agencies in Scandinavia.
    <br />
    <br />
    We work closely with clients all over the world and throughout the years we have
    established a world-wide network making us capable of offering the right solutions
    for both model and client.
    <br />
    <br />
    At Diva the models are our first priority, they are our brand and pride, they are
    human beings and a living example of the quality that exists at Diva Models.
    For us it is important to preserve the spirit of our work. This is done by creating
    a positive environment based on mutual respect and well-being.
    <br />
    <br />
    <a href="http://eepurl.com/rfV9n" target="_blank" rel="noreferrer">Subscribe to our newsletter</a>
  </div>
);
